module.exports = __webpack_public_path__ + "static/media/gtc-logo-white.265ab2e3.png";